<div class="container" style="height: auto">
  <div class="empl-tptxt">
    <h3>Knowledge Bank</h3>
  </div>
  <div class="row" *ngIf="knowledgeArticle">
    <div class="col-lg-12 d-flex" *ngIf="!openedInModel">
      <div class="arrow-left" (click)="back()" (keydown)="back()">
        <img src="../../../assets/images/arrow-left.png" alt="Back" />
      </div>
      <div class="tptxt-gbdpg header-cnt">
        <h4>{{ knowledgeArticle?.details?.heading }}</h4>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="row container-content">
        <div *ngIf="knowledgeArticle?.details?.referenceVideo" class="col-lg-9 col-md-12 mb-2 vedio-card">
          <iframe
            class="embed-responsive-item"
            [src]="knowledgeArticle?.details?.referenceVideo | safeUrl"
            width="100%"
            height="100%"
            title="Reference Video"
            allowfullscreen></iframe>
        </div>
        <div class="col-lg-9 col-md-12 content-background">
          <div class="row">
            <div class="col-12">
              <h3 class="knowledge-article-heading">{{ knowledgeArticle?.details?.heading }}</h3>
              <div [innerHtml]="sanitizedContent"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
